import {
  LegacySearchHit,
  ModernSearchHit,
  SearchHit,
  SearchQueryIndex,
  SearchDisplay,
} from "frontend/types";
import {
  createLegacySearchArticleTease,
  createModernSearchArticleTease,
} from "./search-article-tease";
import { LazyTeaseFeedTease } from "design-system/components/blocks/tease-feed/tease-feed-tease";
import { LazyTeaseRowTease } from "design-system/components/blocks/tease-row/tease-row-tease";
import { createModernSearchProgramTease } from "./search-program-tease";
import { createSearchBookTease } from "./search-book-tease";
import { createModernSearchVideoTease } from "./search-video-tease";
import { isSearchHitType } from "./is-search-hit-type";
import { createModernSearchPersonTease } from "./search-person-tease";
import { createModernSearchParticipantStoryTease } from "./search-participant-story";
import { createEventFeedTeaseProps } from "./search-event-tease";
export function createSearchTease(
  hit: SearchHit,
  index: SearchQueryIndex,
  teaseType?:
    | Exclude<LazyTeaseFeedTease["props"], undefined>["type"]
    | "Best Bet"
    | "Participant Story"
    | "knowledgeBaseArticlePage"
    | "Profile"
    | "Detail"
    | "Landing"
    | "Database"
    | "Dataset"
    | "Video Citation"
    | "Citation",
  siteId?: string,
  template?: string,
): LazyTeaseFeedTease | LazyTeaseRowTease | undefined {
  if (
    (index === "modern" || index === "knowledge" || index === "classnotes") &&
    (isSearchHitType<SearchDisplay>("modern", hit) ||
      isSearchHitType<ModernSearchHit>("modern", hit))
  ) {
    teaseType = teaseType || hit.contentType || "Article";

    if (
      teaseType === "Article" ||
      hit.contentType === "Best Bet" ||
      hit.contentType === "Participant Story" ||
      hit.contentType === "knowledgeBaseArticlePage" ||
      hit.contentType === "Detail" ||
      hit.contentType === "Landing" ||
      hit.contentType === "Database" ||
      hit.contentType === "Dataset" ||
      hit.contentType === "Citation" ||
      (teaseType === "Profile" && !template)
    ) {
      return {
        name: "ArticleTease",
        props: createModernSearchArticleTease(hit, siteId),
      };
    }

    if (teaseType === "Program") {
      return {
        name: "ProgramTease",
        props: createModernSearchProgramTease(hit),
      };
    }

    if (hit.contentType === "Video Citation") {
      return {
        name: "VideoTease",
        props: createModernSearchVideoTease(hit),
      };
    }

    if (teaseType === "Profile") {
      const teaseItem = createModernSearchPersonTease(hit);
      return {
        name: "PersonTease",
        props: teaseItem,
      };
    }

    if (teaseType === "Participant Story") {
      const teaseItem = createModernSearchParticipantStoryTease(hit);
      return {
        name: "ParticipantStoryTease",
        props: teaseItem,
      };
    }
    if (teaseType === "Event" || hit.contentType === "Event") {
      const teaseItem = createEventFeedTeaseProps(hit as SearchDisplay);
      return {
        name: "EventFeedTease",
        props: teaseItem,
      };
    }
  }

  if (index === "legacy" && isSearchHitType<LegacySearchHit>("legacy", hit)) {
    teaseType = teaseType || "Article";
    if (teaseType === "Article") {
      return {
        name: "ArticleTease",
        props: createLegacySearchArticleTease(hit),
      };
    }
    if (teaseType === "Book") {
      return { name: "BookTease", props: createSearchBookTease(hit) };
    }
  }

  //protected index
  if (
    index === "protected" &&
    isSearchHitType<LegacySearchHit>("legacy", hit)
  ) {
    teaseType = teaseType || "Article";
    if (teaseType === "Article") {
      return {
        name: "ArticleTease",
        props: createLegacySearchArticleTease(hit),
      };
    }
  }

  console.warn(
    "createSearchTease > search tease not yet implemented:",
    hit,
    index,
    teaseType,
  );
}
